import { globalApiConfig } from '@/services/telehealthApi/APIConfig'
import {
  type DownloadFileResponse,
  FileApi,
  type FileKindEnum,
  type FileUploadRequestDTO,
  type UploadFileResponse
} from '@/generated'
import axios, { type AxiosProgressEvent, type AxiosRequestHeaders } from 'axios'

export class FileService {
  static readonly fileApi = new FileApi(globalApiConfig)

  static async saveFile(
    file: File,
    fileKind: FileKindEnum,
    caseId: string,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
  ): Promise<void> {
    const { uploadUrl, fileId } = await FileService.getUploadURL(caseId, {
      name: file.name,
      kind: fileKind
    })
    await FileService.uploadFile(file, uploadUrl, onUploadProgress)
    await FileService.finalizeFile(fileId)
  }

  static async getUploadURL(
    caseId: string,
    file: FileUploadRequestDTO
  ): Promise<UploadFileResponse> {
    return (await FileService.fileApi.uploadFile(caseId, file)).data
  }

  static async uploadFile(
    file: File,
    uploadURL: string,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
  ): Promise<void> {
    const headers = {
      'Content-Type': file.type
    } as AxiosRequestHeaders

    await axios.put(uploadURL, file, {
      headers,
      onUploadProgress,
      timeout: 300000
    })
  }

  static async finalizeFile(fileId: string): Promise<void> {
    await FileService.fileApi.finalizeFile(fileId)
  }

  static async getDownloadUrl(fileId: string, inline?: boolean): Promise<DownloadFileResponse> {
    return (await FileService.fileApi.getDownloadUrl(fileId, inline)).data
  }

  static async deleteFile(fileId: string): Promise<void> {
    await FileService.fileApi.deleteFile(fileId)
  }
}
